import React from "react";

import { Grow, Slide } from "@mui/material";

import { TransitionProps } from "@mui/material/transitions";

export const ModalTransition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
    isSlide?: boolean;
  },
  ref: React.Ref<unknown>
) {
  if (props.isSlide) {
    return <Slide direction="up" ref={ref} {...props} />;
  }
  return <Grow ref={ref} {...props} />;
});
